import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Renders one nav menu item.
 *
 * Items that carry `target` (seeded as `flags.target` on nav.role_menu, e.g.
 * Messages / Due / Tasks) point at a separate app and must open in a new tab,
 * so they render as a plain <a> rather than a router <Link> — react-router
 * would otherwise try to resolve the URL against the current route.
 *
 * Everything else keeps SPA navigation via <Link>.
 */
const MenuLink = ({ item, children, ...rest }) => {
  const path = item?.path || '';
  const isAbsolute = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(path);
  const target = item?.target || (isAbsolute ? '_blank' : undefined);

  if (target) {
    return (
      <a href={path} target={target} rel="noopener noreferrer" {...rest}>
        {children}
      </a>
    );
  }

  return (
    <Link to={path} {...rest}>
      {children}
    </Link>
  );
};

export default MenuLink;
